var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21C4.46988 21 0.279883 12.8 0.109883 12.45C-0.0301172 12.17 -0.0301172 11.84 0.109883 11.56C0.279883 11.2 4.46988 3 11.9999 3C19.5299 3 23.7199 11.2 23.8899 11.55C24.0299 11.83 24.0299 12.16 23.8899 12.44C23.7199 12.79 19.5299 20.99 11.9999 20.99V21ZM2.13988 12C3.07988 13.61 6.61988 19 11.9999 19C17.3799 19 20.9199 13.61 21.8599 12C20.9199 10.39 17.3799 5 11.9999 5C6.61988 5 3.07988 10.39 2.13988 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 16C9.78989 16 7.99989 14.21 7.99989 12C7.99989 9.79 9.78989 8 11.9999 8C14.2099 8 15.9999 9.79 15.9999 12C15.9999 14.21 14.2099 16 11.9999 16ZM11.9999 10C10.8999 10 9.99989 10.9 9.99989 12C9.99989 13.1 10.8999 14 11.9999 14C13.0999 14 13.9999 13.1 13.9999 12C13.9999 10.9 13.0999 10 11.9999 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye-black.03b84381860d32b3e90d2a2b6b20749f.svg";
export { ForwardRef as ReactComponent };